import { dispatchRightClickEvent } from '@chart/core/events/events';
import { BaseChartAPIProps } from '@chart/types/create.types';
import { isWithinYAxis } from '@chart/utils/axis/axis-utils';

import { ChartStoreReturn } from '../create/chart-store/chartStore';

export const onMouseRightClick = (
  event: MouseEvent,
  chartStore: ChartStoreReturn
) => {
  const base = chartStore.getState().base as BaseChartAPIProps;
  event.preventDefault();

  dispatchRightClickEvent({
    base,
    mouseX: event.offsetX,
    mouseY: event.offsetY,
    isWithinYAxis: isWithinYAxis(event, base.options),
  });
};
